import styled from "@emotion/styled";
import { Box, Button, Grid, } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router-dom";
import { FC } from "react";
import React from "react";
import { listPublicManagementIndicators } from "graphql/queries";
import { generateClient } from "aws-amplify/api";
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { sessionDisconnectedCheck } from "shared/sessionDisconnectedCheck";
import { SystemErrorTitle, SystemErrorMsg } from "../../constants";
import activateSession from 'shared/activateSession';
import swal from 'sweetalert2';
import "./TopPage.css";
import { BackdropLoading } from "shared/backdropLoading";

const BorderSpan = styled.span`
    font-weight: bold;
`;

const AppliedGrid01 = styled(Grid)(({ }) => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1.3rem',
    height: '6rem',
    lineHeight: '2.1rem',
    padding: '0rem'
}));

const AppliedGrid02 = styled(Grid)(({ }) => ({
    backgroundColor: '#41DBCE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1.3rem',
    height: '6rem',
    lineHeight: '2.1rem',
    padding: '0rem'
}));

const NotAppliedGrid = styled(Grid)(({ }) => ({
    backgroundColor: '#A6A6A6',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1.3rem',
    height: '6rem',
    lineHeight: '1.7rem',
    padding: '0rem'
}));

const AppliedButton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'left',
    fontSize: 'clamp(0.8rem, 1.5vw, 1.3rem)',
    fontWeight: 'bold',
    height: '3rem',
    width: '62.5%',
    borderRadius: '100rem',
}));

const NotAppliedButton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    height: '2.3rem',
    width: '15rem',
    borderRadius: '100rem',
}));

const HelpArea = styled(Box)(({ }) => ({
    backgroundColor: '#A6A6A6',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1.3rem',
    lineHeight: '2.3rem',
    padding: '0',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
}));

const HelpButton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'center',
    fontSize: 'clamp(0.8rem, 1.5vw, 1.3rem)',
    fontWeight: 'bold',
    height: '2.7rem',
    width: '62.5%',
    borderRadius: '100rem',
}));

const screenId = "U020"

const TopPage: FC = () => {
    const [yearEdition1, setYearEdition1] = React.useState("")
    const [contractFlg1, setContractFlg1] = React.useState(false)
    const [edition1StartYear, setEdition1StartYear] = React.useState("")
    const [edition1StartMonth, setEdition1StartMonth] = React.useState("")
    const [edition1StartDay, setEdition1StartDay] = React.useState("")
    const [yearEdition2, setYearEdition2] = React.useState("")
    const [edition2StartYear, setEdition2StartYear] = React.useState("")
    const [edition2StartMonth, setEdition2StartMonth] = React.useState("")
    const [edition2StartDay, setEdition2StartDay] = React.useState("")
    const [contractFlg2, setContractFlg2] = React.useState(false)
    const [loading, setLoading] = React.useState(true);
    const [activating, setActivating] = React.useState(false);
    const [concurrentFlg, setConcurrentFlg] = React.useState(false);
    const [beforeStartFlg, setBeforeStartFlg] = React.useState(false);
    const [beforeStartFlg2, setBeforeStartFlg2] = React.useState(false);

    React.useEffect(() => {
        const interval = setInterval(async () => {
            // セッションの有効性確認
            if (await sessionDisconnectedCheck(screenId, "polling", "", navigate)) {
                return;
            }
        }, 30000);
        return () => clearInterval(interval);
    }, []);

    React.useEffect(() => {
        window.scrollTo(0, 0)
        // 参照可能な経営情報の最新2期を取得
        const getPublicManagementIndicators = async () => {
            try {
                let allItems: any[] = [];
                let nextToken: string | null = null;
                const dt = new Date();
                const year = dt.getFullYear();
                const month = ("00" + (dt.getMonth() + 1)).slice(-2);
                const day = ("00" + (dt.getDate())).slice(-2);
                const nowDate = year + month + day;
                do {
                    const client = generateClient();
                    const result: any = await client.graphql({
                        query: listPublicManagementIndicators,
                        variables: { limit: 500, nextToken: nextToken, filter: { and: [{ usingStartDate: { le: nowDate } }, { usingEndDate: { ge: nowDate } }, { _deleted: { ne: true } }] } },
                    });
                    const items = result.data?.listPublicManagementIndicators?.items || [];
                    nextToken = result.data?.listPublicManagementIndicators?.nextToken || null;
                    allItems = allItems.concat(items)
                } while (nextToken);
                // 有効な決算期を最新期から降順に並べる
                allItems.sort((a: any, b: any) => b.yearEdition - a.yearEdition);
                let yearEdition1 = allItems[0] ? allItems[0].yearEdition : ""
                let yearEdition2 = allItems[1] ? allItems[1].yearEdition : ""
                setYearEdition1(yearEdition1)
                setYearEdition2(yearEdition2)
                // セッション情報から各年版の契約有無を確認する
                const session = await fetchAuthSession();
                // 多重ログイン確認用フラグ
                const concurrentFlg = session?.tokens?.idToken?.payload?.concurrentFlg;
                console.log("concurrentFlg", concurrentFlg);
                const contractInfoDataList = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]")
                for (const contractInfoData of contractInfoDataList) {
                    if (contractInfoData.yearEdition == yearEdition1) {
                        setEdition1StartYear(contractInfoData.usingStartDate.slice(0, 4))
                        setEdition1StartMonth(contractInfoData.usingStartDate.slice(4, 6))
                        setEdition1StartDay(contractInfoData.usingStartDate.slice(6, 8))
                        if (nowDate < contractInfoData.usingStartDate) {
                            setBeforeStartFlg(true)
                        } else {
                            setContractFlg1(true)
                        }
                    }
                    if (contractInfoData.yearEdition == yearEdition2) {
                        setEdition2StartYear(contractInfoData.usingStartDate.slice(0, 4))
                        setEdition2StartMonth(contractInfoData.usingStartDate.slice(4, 6))
                        setEdition2StartDay(contractInfoData.usingStartDate.slice(6, 8))
                        if (nowDate < contractInfoData.usingStartDate) {
                            setBeforeStartFlg2(true)
                        } else {
                            setContractFlg2(true)
                        }
                    }
                }
                setLoading(false);
            } catch (err) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            }
        };
        (async () => {
            const session = await fetchAuthSession();
            const concurrentFlg = session?.tokens?.idToken?.payload?.concurrentFlg;
            const isLoginChecked = sessionStorage.getItem("isLoginChecked");

            if (isLoginChecked) {
                // セッションの有効性確認
                if (await sessionDisconnectedCheck(screenId, "getPublicManagementIndicators", "", navigate)) {
                    return
                }
                getPublicManagementIndicators()
            } else {
                if (concurrentFlg == "1") {
                    setConcurrentFlg(true)
                } else {
                    // セッションの有効性確認
                    if (await sessionDisconnectedCheck(screenId, "getPublicManagementIndicators", "", navigate)) {
                        return
                    }
                }
                getPublicManagementIndicators()
            }
        })()
    }, []);

    const navigate = useNavigate();

    const onClickFinancialRatio = async (yearEdition: string) => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "onClickFinancialRatio", yearEdition, navigate)) {
            return
        }
        navigate("/SearchFinancialRatio", { state: { yearEdition: yearEdition } });
    };

    const onClickFinancialAnalysis = async (yearEdition: string) => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "onClickFinancialAnalysis", yearEdition, navigate)) {
            return
        }
        navigate("/FinancialAnalysis", { state: { yearEdition: yearEdition } });
    };

    // 初期表示時の検索完了までは何も表示しない
    if (loading) {
        return <div></div>;
    }

    // 多重ログイン発生時にエラーモーダルを表示してログアウト
    if (concurrentFlg && !activating) {
        swal.fire({
            title: "他のユーザーがログイン中です。\n操作を続けますか？",
            showDenyButton: true,
            confirmButtonText: "OK",
            denyButtonText: `キャンセル`,
            allowOutsideClick: false,
            customClass: {
                title: 'title',
                confirmButton: 'confirmButton',
                denyButton: 'denyButton'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                setActivating(true)
                var res = await activateSession();
                if (res == "E9999") {
                    navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
                } else {
                    sessionStorage.setItem("isLoginChecked", "true");
                }
                setActivating(false)
            } else if (result.isDenied) {
                // サインアウト(Authenticator)
                signOut();
            }
            setConcurrentFlg(false)
        });
    }

    return (
        <>
            <BackdropLoading open={activating} />
            <div className="css-ihr0n2"><img src="/topPage.jpg" /></div>
            <div>
                {
                    yearEdition1 && (contractFlg1 ?
                        <AppliedGrid01>
                            <Grid>
                                <BorderSpan>{yearEdition1}年版</BorderSpan>
                            </Grid>
                            <Grid container>
                                <Grid size={2}></Grid>
                                <Grid size={4}>
                                    <AppliedButton variant="contained" color="secondary" onClick={() => onClickFinancialRatio(yearEdition1)}><SearchIcon style={{ marginRight: '0.8rem', color: '#41DBCE', }} />標準財務比率検索
                                    </AppliedButton>
                                </Grid>
                                <Grid size={4}>
                                    <AppliedButton variant="contained" color="secondary" onClick={() => onClickFinancialAnalysis(yearEdition1)}><img src={`${process.env.PUBLIC_URL}/Icons/analyzeIcon.svg`} width="30px" />&nbsp;&nbsp;財務分析</AppliedButton>
                                </Grid>
                                <Grid size={2}></Grid>
                            </Grid>
                        </AppliedGrid01>
                        :
                        (beforeStartFlg ?
                            <NotAppliedGrid>
                                <Grid>
                                    <BorderSpan>{yearEdition1}年版</BorderSpan>
                                </Grid>
                                <Grid sx={{ fontSize: '1.3rem', marginTop: '1rem' }}>
                                    ご契約の年版は{edition1StartYear}年{edition1StartMonth}月{edition1StartDay}日からご利用可能です。
                                </Grid>
                            </NotAppliedGrid>
                            :
                            <NotAppliedGrid>
                                <Grid>
                                    <BorderSpan>{yearEdition1}年版</BorderSpan>
                                </Grid>
                                <Grid sx={{ fontSize: '1rem' }}>
                                    現在「{yearEdition1}年版」のお申込みがされていないため、ご利用いただくことができません。
                                </Grid>
                                <Grid>
                                    <NotAppliedButton variant="contained" color="secondary" onClick={() => window.open("https://go.tsr-net.co.jp/order_sme-indicators.html?Product_Interest=sme-customer")}>{yearEdition1}年版お申込み</NotAppliedButton>
                                </Grid>
                            </NotAppliedGrid>
                        )
                    )
                }
            </div>
            <div>
                {
                    yearEdition2 && (contractFlg2 ?
                        <AppliedGrid02 sx={{ borderTop: '2px solid #FFFFFF' }}>
                            <Grid>
                                <BorderSpan>{yearEdition2}年版</BorderSpan>
                            </Grid>
                            <Grid container>
                                <Grid size={2}></Grid>
                                <Grid size={4}>
                                    <AppliedButton variant="contained" color="secondary" onClick={() => onClickFinancialRatio(yearEdition2)}><SearchIcon style={{ marginRight: '0.8rem', color: '#41DBCE', }} />標準財務比率検索
                                    </AppliedButton>
                                </Grid>
                                <Grid size={4}>
                                    <AppliedButton variant="contained" color="secondary" onClick={() => onClickFinancialAnalysis(yearEdition2)}><img src={`${process.env.PUBLIC_URL}/Icons/analyzeIcon.svg`} width="30px" />&nbsp;&nbsp;財務分析</AppliedButton>
                                </Grid>
                                <Grid size={2}></Grid>
                            </Grid>
                        </AppliedGrid02>
                        :
                        (beforeStartFlg2 ?
                            <NotAppliedGrid sx={{ borderTop: '2px solid #FFFFFF' }}>
                                <Grid>
                                    <BorderSpan>{yearEdition2}年版</BorderSpan>
                                </Grid>
                                <Grid sx={{ fontSize: '1.3rem', marginTop: '1rem' }}>
                                    ご契約の年版は{edition2StartYear}年{edition2StartMonth}月{edition2StartDay}日からご利用可能です。
                                </Grid>
                            </NotAppliedGrid>
                            :
                            <></>
                        )
                    )
                }
            </div>
            <HelpArea sx={{ marginTop: '0.7rem', marginBottom: '0.7rem' }}>
                <Grid container>
                    <Grid size={2} />
                    <Grid size={4}>
                        <HelpButton variant="contained" color="secondary" onClick={() => window.open("https://www.tsr-net.co.jp/static/sme-indicators/introduction/index.html")}>財務分析入門</HelpButton>
                    </Grid>
                    <Grid size={4}>
                        <HelpButton variant="contained" color="secondary" onClick={() => window.open("https://www.tsr-net.co.jp/terms")}>利用約款</HelpButton>
                    </Grid>
                    <Grid size={2} />
                </Grid>
            </HelpArea>
        </>
    );
}
export default TopPage;
